import React, { ComponentType } from "react";
import { StripeProvider } from "../Contexts/StripeContext";

export const withStripe = <P extends object>(Component: ComponentType<P>) => {
  const WrappedComponent = (props: P) => {
    return (
      <StripeProvider>
        <Component {...props} />
      </StripeProvider>
    );
  };

  return WrappedComponent;
};
